export function setCookie({
  name,
  value,
  expires,
  sameSite = 'Lax',
  secure = globalThis.location?.protocol === 'https:',
}) {
  const expireAt = expires && new Date(expires).toUTCString()

  const isSecure = sameSite === 'None' ? true : secure

  let cookieString = `${name}=${value};expires=${expireAt};path=/;`

  if (sameSite) {
    cookieString += `SameSite=${sameSite};`
  }
  if (isSecure) {
    cookieString += 'Secure;'
  }

  document.cookie = cookieString
}

export function getCookie(cname) {
  const name = `${cname}=`
  const ca = document.cookie.split(';')

  for (let c of ca) {
    while (c.charAt(0) === ' ') {
      c = c.slice(1)
    }
    if (c.indexOf(name) === 0) {
      return c.slice(name.length, c.length)
    }
  }
  return ''
}

export const clearCookie = (cname) => {
  const expiresAt = new Date(-1).toUTCString()

  setCookie({ name: cname, value: '', expires: expiresAt })
}

export const renewCookie = (cname, extendTime) => {
  if (typeof globalThis.window !== 'undefined' && globalThis.cookieStore) {
    globalThis.cookieStore.get(cname).then((cookie) => {
      if (cookie) {
        const { expires: expirationTime, ...restInfo } = cookie

        // if less than 3 minute, renew the cookie's expiration time
        const isGonnaExpired = (new Date(expirationTime) - Date.now()) / 3_600_000 <= 0.05

        if (isGonnaExpired) {
          const extendedExpiryTime = Date.now() + extendTime
          setCookie({ expires: extendedExpiryTime, ...restInfo })
        }
      }
    })
  }
}

export const getCookieData = (cname) => {
  if (cname) {
    if (typeof globalThis.window !== 'undefined' && globalThis.cookieStore) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          const result = await globalThis.cookieStore.get(cname)
          resolve(result)
        }, 1000)
      })
    }
  }
  return null
}

export const clearCookieForPunchoutSystem = () => {
  clearCookie('PUNCHOUT_SESSION_ID')
  clearCookie('PUNCHOUT_TEMPLATE_TYPE')
}
